import React from 'react';
import BaseType from './BaseType';

const ReplyReceived = ({ item }) => {
  return (
    <BaseType
      url={item.metadata?.known_org?.logo_url}
      name={item.metadata?.known_org?.name}
      tagType='positive'
      tagText={
        <>
          💬&nbsp;&nbsp;Reply from <b>{item?.metadata?.prospect?.name}</b>
        </>
      }
      tagTo={`/prospect/${item?.metadata?.prospect?.id}`}
      time={item.time}
      conversationId={item.id}
    />
  );
};

export default ReplyReceived;
